import { POST } from '@wellsfargo/ecpfs-authority'

export const REGISTRATION_TERMS_OF_USE_PATH = 'login/footer/toc/text.json'

export function fetchRegistrationTermsOfUse(brandId) {
	return POST(REGISTRATION_TERMS_OF_USE_PATH, { brandId })
}
